import * as IncidentsConstants from './IncidentsConstants';
import { produce } from "immer";
// Object.assign is not yet fully supported in all browsers, so we fallback to a polyfill
const assign = Object.assign || require('object.assign');

const initialState ={
    isIncidentsFetched: false,
    isIncidentFetching: false,
    isIncidentFailed: false,
    incidentsData: [],
    incidentFilterState: {}
};

export default function IncidentsReducer(state = {}, action) {

    switch (action.type) {

        case  IncidentsConstants.INCIDENTS_DATA_STATE_ADD: {
            const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                }
            });
            return assign({}, state, newState);
        }

        case IncidentsConstants.INCIDENTS_DATA_STATE_REMOVE: {
            const newState = produce(state, (draft) => {
                if (draft[action.payload]) {
                    delete draft[action.payload];
                }
            });
            return assign({}, newState);
        }

        case IncidentsConstants.INCIDENTS_DATA_FETCHING:{
           
            const newState = produce(state, (draft) => {
                draft[action.payload.deviceId] = {
                    ...draft[action.payload.deviceId],
                    incidentsData: action.payload.fetchNext ? draft[action.payload.deviceId]?.incidentsData : [],
                    isIncidentsFetched: false,
                    isIncidentFetching: true,
                    isIncidentFailed: false,
                    pageConfig: action.payload.pageConfig
                }
                
            });
            return assign({}, state,newState);
        }
        
        case IncidentsConstants.INCIDENTS_DATA_FETCHED: {
            
            const newState = produce(state, (draft) => {
                draft[action.payload.deviceId] = {
                    ...draft[action.payload.deviceId],
                    isIncidentsFetched: true,
                    isIncidentFetching: false,
                    isIncidentFailed: false,
                    incidentsData: action.payload.fetchNext ? [...draft[action.payload.deviceId].incidentsData, ...action.payload.newState.result] : action.payload.newState.result,
                    hasMore: action.payload.newState.result?.length === action.payload.requestedPageSize
                }
            });

            return assign({}, state,newState);
        }

        case IncidentsConstants.INCIDENTS_DATA_FETCHING_FAILED:{
           const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    isIncidentsFetched: false,
                    isIncidentFetching: false,
                    isIncidentFailed: true
                }
            });

            return assign({}, state,newState);
        }

        case IncidentsConstants.INCIDENTS_FILTER_STATE:{
            
            const newState = produce(state, (draft) => {
                draft[action.newState.deviceID] = {
                    ...draft[action.newState.deviceID],
                    incidentFilterState: action.newState
                };
            });
            
            return assign({}, state,newState);
        }  
        
        default: {
            return state;
        }

    }

}